import EBarFeatureBlock from './EBarFeatureBlock';

export default EBarFeatureBlock;
